import React from 'react';
import ModalPopUp from '@Components/UI/Modal/ModalPopUp';
import { panels, layouts, buttons, textblocks } from 'seal-ui-components';
import {
    LabelsHelpModalContent,
    ContractsHelpModalContent,
    ScorecardsHelpModalContent,
    SettingsHelpModalContent,
    ClausesHelpModalContent,
    MarkupHelpModalContent
} from './components';
import styled, { withTheme } from 'styled-components';
import style from './HelpModal.style';

const HelpModal = ({ onRequestClose, pathname, className, theme }) => (
    <ModalPopUp onRequestClose={onRequestClose} className={className}>
        <layouts.VerticalBox style={{ height: '100vh', minHeight: '100vh' }}>
            <layouts.HorizontalBox className="help-modal-header">
                <textblocks.Heading4>{`${pathname} help`}</textblocks.Heading4>
                <layouts.BoxSpacer />
                <buttons.Button appearance="primary" size="medium" onClick={() => onRequestClose()}>
                    Close
                </buttons.Button>
            </layouts.HorizontalBox>
            <panels.ScrollPanel>
                <layouts.VerticalBox
                    padding={`${theme.spaces.default.l} ${theme.spaces.default.xs}
            ${theme.spaces.default.xs} ${theme.spaces.default.m}`}
                >
                    {
                        {
                            contracts: <ContractsHelpModalContent />,
                            labels: <LabelsHelpModalContent />,
                            clauses: <ClausesHelpModalContent />,
                            scorecards: <ScorecardsHelpModalContent />,
                            markup: <MarkupHelpModalContent />,
                            settings: <SettingsHelpModalContent />
                        }[pathname]
                    }
                </layouts.VerticalBox>
            </panels.ScrollPanel>
        </layouts.VerticalBox>
    </ModalPopUp>
);

export default styled(withTheme(HelpModal))`
    ${style};
`;
